import { Avatar, type SxProps } from '@mui/material';
import type { FC, ReactElement } from 'react';

interface UserAvatarProps {
  src?: string;
  userInitials?: string;
  height?: string | number;
  width?: string | number;
  variant?: 'rounded' | 'circular' | 'square';
  sx?: SxProps;
  id?: string;
}

const UserAvatar: FC<UserAvatarProps> = (props): ReactElement => {
  const {
    src = '',
    userInitials,
    height = '30px',
    width = '30px',
    variant = 'circular',
    sx = {},
    id,
  } = props;

  return (
    <Avatar
      id={id}
      sx={{
        height, width, fontSize: '14px', ...sx,
      }}
      variant={variant}
      src={src}
    >
      {userInitials}
    </Avatar>
  );
};

export default UserAvatar;
